import {
    createFeatureSelector,
    DefaultProjectorFn,
    MemoizedSelector,
} from '@ngrx/store';
import {
    userBidHistoryFeatureKey,
    UserBidHistoryState,
} from './user-bid-history.reducer';

export const selectUserBidHistoryState: MemoizedSelector<
    object,
    UserBidHistoryState,
    DefaultProjectorFn<UserBidHistoryState>
> = createFeatureSelector<UserBidHistoryState>(userBidHistoryFeatureKey);
